import React from "react";

/**
 * The envelope-with-tick mark: small in the hero eyebrow, oversized as the
 * watermark on the closing panel. Geometry taken verbatim from the reference
 * (4:3 viewBox, so give it a 4:3 box or it will letterbox).
 */
const Envelope = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 64 48"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="2"
      y="4"
      width="60"
      height="40"
      rx="4"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <path
      d="M2 8 L32 28 L62 8"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M46 38 l4 4 8 -10"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Envelope;
